import { OptionI, Options } from '@/utils/forms/optionBuilders'

import { IncidentFiltersFormInputsI } from '../types/form'

export const removeEmptyFilters = (values: IncidentFiltersFormInputsI) => {
  return Object.keys(values).forEach((key) => {
    // Delete null values and empty arrays
    if (values[key] === null || values[key]?.length == 0) {
      delete values[key]
    }
  })
}

export const compareAlphabetically = (
  a: { name: string },
  b: { name: string }
) => (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1)

export const dummyDeviceId = '00000000-0000-0000-0000-000000000000'

export const areAllDefined = (...entities: (object | undefined)[]): boolean => {
  return entities.every((entity) => entity !== undefined)
}

export const hasFacilitiesOrFloors = (
  watchFacility: OptionI[] | undefined,
  watchFloor: OptionI[] | undefined
): boolean => watchFacility?.length > 0 || watchFloor?.length > 0

/**
 * Merges pre-selected facilities with initial facility options.
 * This ensures pre-selected facilities always appear in the dropdown,
 * even if they're not in the initial 100 facilities fetched.
 */
export const getMergedFacilityOptions = (
  preSelectedFacilities: Options,
  initialFacilities: Options | undefined
): Options => {
  const baseFacilities = initialFacilities ?? []

  // Create a map to deduplicate by facility ID
  const facilityMap = new Map<string, OptionI>()

  // Add pre-selected facilities first (ensures they're always included)
  preSelectedFacilities.forEach((facility) => {
    if (facility.value) {
      facilityMap.set(facility.value, facility)
    }
  })

  // Add initial facilities (will not overwrite existing)
  baseFacilities.forEach((facility) => {
    if (facility.value && !facilityMap.has(facility.value)) {
      facilityMap.set(facility.value, facility)
    }
  })

  return Array.from(facilityMap.values())
}
